// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ur","itemWrapper":"us s4","itemStyle":"ut s5"};